// Finds the actual target for a scrollable container.
// Supports virtual scroller, Swiper, Vue components, and DOM elements.

export default function getScrollTarget(ref) {
  if (typeof ref === "string") {
    return document.querySelector(ref);
  }

  if (!ref || !ref.value) {
    return null;
  }

  if ("__swiper__" in ref.value) {
    return ref.value;
  }

  if ("$el" in ref.value) {
    return ref.value.$el;
  }

  return ref.value;
}
